import {ApplicationRef, Injectable} from '@angular/core';
import {SwUpdate} from '@angular/service-worker';
import {concat, interval} from 'rxjs';
import {first} from 'rxjs/operators';

// https://angular.dev/ecosystem/service-workers/communications

/// This service is most useful for the installed PWA. The installed app does not actually reload unless we fully quit it
/// and restart it. Only then the notification of a new version would be displayed. Now we actively check for updates.
/// This service is also useful for the browser if the user stays on the app for many hours without a full reload.
@Injectable({providedIn: 'root'})
export class CheckForUpdateService {

  constructor(
    appRef: ApplicationRef,
    updates: SwUpdate
  ) {
    // Allow the app to stabilize first, before starting
    // polling for updates with `interval()`.
    const appIsStable$ = appRef.isStable.pipe(first((isStable) => isStable === true));
    const everySixHours$ = interval(6 * 60 * 60 * 1000);
    const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everySixHours$);
    everySixHoursOnceAppIsStable$.subscribe(async () => {
      try {
        const updateFound = await updates.checkForUpdate();
        console.log(updateFound ? 'A new version is available.' : 'Already on the latest version.');
      } catch (err) {
        console.error('Failed to check for updates:', err);
      }
    });
  }

}
